import * as Sentry from '@sentry/react';

import { config } from '../config/loader.js';
import { environment } from './environments.js';

/** @see https://docs.sentry.io/platforms/javascript/configuration/ */
export function initSentry(): void {
  Sentry.init({
    enabled: config.sentryEnabled,
    environment,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, maskAllInputs: false, blockAllMedia: false }),
    ],
    dsn: 'https://79169d3073e0d893af6b518d217a2f33@o4507414517055488.ingest.us.sentry.io/4507415167369216',
    tracePropagationTargets: [
      'localhost',
      // Include all alveole.buzz domains EXCEPT auth
      /^https:\/\/(?!(auth-dev\.|auth\.).).*\.alveole\.buzz/,
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
